import { render, staticRenderFns } from "./EditarEnvioInformacionModal.vue?vue&type=template&id=59a76a8f&"
import script from "./EditarEnvioInformacionModal.vue?vue&type=script&lang=ts&"
export * from "./EditarEnvioInformacionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports